export const lengthBetween = {
    validate: (value, params) => {
        const length = value && value.length;
    
        return length >= params['min'] && length <= params['max'];
    },
    params: ['min', 'max'],
    message: 'Độ dài trường {_field_} phải nằm giữa {min} và {max}',
};